export default "__VITE_ASSET__CF_7UzzQ__"